<template>
  <div>
    <p>
      <img :src="icon" alt="" uk-svg />
    </p>
    <p>
      <strong>{{title}}</strong><br>
      <slot />
    </p>
  </div>
</template>

<script>
import PercentageIcon from '@/assets/images/icons/icon-percentage.svg';

export default {
  name: 'ExplainBlock.vue',
  props: {
    title: String,
    icon: {
      default: PercentageIcon,
    },
  },
};
</script>
